import { css } from "@vitality-ds/system";
export default css({
  transition: "opacity 300ms",
  opacity: 1,
  display: "flex",
  gap: "$sm",
  alignItems: "baseline",
  variants: {
    isLoading: {
      "true": {
        opacity: 0
      }
    }
  }
});